// extracted by mini-css-extract-plugin
export default {"timings":"_1j9ZOTAD","time":"_3wUNjiWp"};